
<div class="p-0 m-0">
  <div class="border p-2 mb-2 rounded-md border-gray-300">
    <p class="label-mini-section">
      {{ $t("workspace_rde.rde_detail.label.register_install_packages") }}
    </p>
    <div class="grid grid-cols-4 mt-0">
      <v-autocomplete
        id="rde-input-java-version"
        v-model="values.installPackages.javaVersion"
        :items="javaVersions"
        :label="$t('workspace_rde.rde_detail.label.java_version')"
        small-chips
        :placeholder="
          $t('workspace_rde.rde_detail.placeholder.select_java_version')
        "
        class="app-g-autocomplete-v2"
        outlined
        dense
      />
      <v-autocomplete
        id="rde-input-node-version"
        v-model="values.installPackages.nodeVersion"
        :items="nodeVersions"
        :label="$t('workspace_rde.rde_detail.label.node_version')"
        small-chips
        :placeholder="
          $t('workspace_rde.rde_detail.placeholder.select_node_version')
        "
        class="app-g-autocomplete-v2"
        outlined
        dense
      />
      <v-autocomplete
        id="rde-input-apt-packages"
        v-model="values.installPackages.aptPackages"
        :items="linuxPackages"
        :label="$t('workspace_rde.rde_detail.label.linux_packages')"
        small-chips
        :placeholder="
          $t('workspace_rde.rde_detail.placeholder.select_linux_packages')
        "
        class="app-g-autocomplete-v2"
        clearable
        deletable-chips
        outlined
        dense
        multiple
      />
      <v-autocomplete
        id="rde-input-pip-packages"
        v-model="values.installPackages.pipPackages"
        :items="pythonPackages"
        :label="$t('workspace_rde.rde_detail.label.python_packages')"
        small-chips
        :placeholder="
          $t('workspace_rde.rde_detail.placeholder.select_python_packages')
        "
        class="app-g-autocomplete-v2"
        clearable
        deletable-chips
        outlined
        dense
        multiple
      />
    </div>
  </div>
  <div class="border p-2 mb-2 rounded-md border-gray-300">
    <p class="label-mini-section">
      {{ $t("workspace_rde.rde_detail.label.register_pre_start_script") }}
    </p>
    <v-autocomplete
      id="rde-input-preflightConfig-name"
      v-model="values.installPackages.preflightConfig.name"
      :items="preflightConfigResourceNames"
      small-chips
      :placeholder="$t('workspace_rde.rde_detail.label.resource_name')"
      :label="$t('workspace_rde.rde_detail.placeholder.resource_name')"
      class="app-g-autocomplete-v2 pt-2 v-auto-help-message"
      outlined
      dense
      :messages="
        values.installPackages.preflightConfig.configType
          ? `${$t('common.base.label.type')}: ${
              values.installPackages.preflightConfig.configType
            }`
          : ''
      "
      @change="onChangePreflightResourceName"
    />
  </div>
  <div class="border p-2 mb-2 rounded-md border-gray-300">
    <p class="label-mini-section">
      {{ $t("workspace_rde.rde_detail.label.file_env_mount") }}
    </p>
    <FileEnvironment
      :mountedConfigList="values.installPackages.mountedConfigList"
      :installPackages="installPackages"
      :resourceNames="resourceNames"
      @change="setValue('installPackages.mountedConfigList', $event)"
    />
  </div>

  <div class="border p-2 mb-2 rounded-md border-gray-300">
    <p class="label-mini-section">
      {{ $t("workspace_rde.rde_detail.label.register_shared_storage") }}
    </p>
    <StorageShare
      :mountedFSList="values.installPackages.mountedFSList"
      :installPackages="installPackages"
      :validate="validate"
      @change="setValue('installPackages.mountedFSList', $event)"
    />
  </div>
</div>
